/*!--------------------------------------------------------
 * Copyright (C) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
/*---------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
define("vs/code/browser/workbench/workbench.nls", {
	"vs/code/browser/workbench/workbench": [
		"$(remote) VS Code Web Playground: {0}/{1}",
		"VS Code Web Playground: {0}/{1}",
		"$(remote) VS Code Web Playground",
		"VS Code Web Playground"
	]
});